import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const c = i((s, t) => /* @__PURE__ */ o.jsx(
  r,
  {
    ref: t,
    ...s,
    image: (e) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "0 0 64 64",
        ...e,
        children: [
          /* @__PURE__ */ o.jsx("path", { fill: "#FDF7BE", d: "M0 0h64v64H0z" }),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "#2D2926",
              d: "m29.89 20.741 5.576 15.542H24.498zm15.195 25.867L32.474 12h-2.4l-11.62 32.729c-1.175 3.288-2.053 4.514-4.871 4.514H13V52h13.255v-2.757h-.53c-2.932 0-4.34-.47-4.34-2.583 0-.705.234-2.114.643-3.227l1.583-4.166h12.725l2.287 6.75c.296.817.409 1.46.409 1.939 0 1.348-1.348 1.235-4.87 1.287V52h15.246v-2.757c-2.862-.052-3.444-.235-4.323-2.636"
            }
          )
        ]
      }
    )
  }
));
c.displayName = "AgencyLogoStickerIcon";
export {
  c as AgencyLogoStickerIcon,
  c as default
};
//# sourceMappingURL=index.js.map
